import React from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CModal,
  CModalBody,
} from '@coreui/react-pro'
import {
  setAttachClientToPartnerProfile,
  submitEditPartner,
} from 'src/pages/ib/partners/attach/model'
import { useAttachClientToPartnerProfile } from 'src/pages/ib/partners/attach'

type Props = {
  isVisible: boolean
  onClose: () => void
  clientId: string
}
export const AttachPartnerToClientModal: React.FC<Props> = ({
  clientId,
  isVisible,
  onClose,
}) => {
  let { attachClientToPartnerProfile, loading, errorAttachClientToPartner } =
    useAttachClientToPartnerProfile()

  const { partnerUserId } = attachClientToPartnerProfile

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    setAttachClientToPartnerProfile({
      ...attachClientToPartnerProfile,
      [event.currentTarget.name]: Number(event.currentTarget.value),
    })
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      <CModalBody>
        <CCol xs={8} className="mb-2">
          <>
            <div>
              <CFormInput
                className="mb-2"
                type="number"
                id="partnerUserId"
                name="partnerUserId"
                placeholder="Partner ID"
                label="Partner ID"
                value={partnerUserId}
                onChange={handleChange}
              />
            </div>
            <div>
              <CButton
                disabled={loading}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish attach client ${clientId} to a partner ${attachClientToPartnerProfile.partnerUserId}?`,
                    )
                  ) {
                    submitEditPartner(attachClientToPartnerProfile)
                    setAttachClientToPartnerProfile({
                      ...attachClientToPartnerProfile,
                      partnerUserId: '',
                    })
                    onClose()
                  }
                }}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                Attach
              </CButton>
            </div>
          </>
        </CCol>
      </CModalBody>
    </CModal>
  )
}
